<template>
  <PageHeader :showBreadcrumb="false" />
  <p>
    Welcome to the Managed Care Systems portal!
  </p>
  <div class="container p-3 text-center">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">File an Appeal or Complaint</h2>
          <Button size="lg" class="me-2" rounded raised label="Go to Appeal or Complaint" severity="primary" @click="router.push('/appealsAndComplaints');"/>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">MCS Portal Sign In for HMOs, CBPs, PBMs, and Insurance Companies</h2>
          <Button size="lg" class="me-2" rounded raised label="Go to MCS Portal Sign In" severity="primary" @click="router.push('/SignInRegister');"/>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer">
    <div class="container">
      <p>Version {{appVersion}}</p>
    </div>
  </footer>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
import router from "@/router/index.js";
import Button from "primevue/button";
const appVersion = import.meta.env.PACKAGE_VERSION;
</script>

<style scoped>
.portal-box {
  height: 200px;
}
.tx-col {
  height: 75%;
}
.footer {
  padding: 1rem;
  text-align: center;
}
</style>